(async () => {
    const { Core } = await importModule('Core');

    customElements.define('cart-drawer-trigger', class extends Core {

        render() {
            this.addEventListener('click', this._openModal.bind(this))
        }

        _openModal(e) {
            e.preventDefault();
            this.publish('drawer:open');
        }
    })
})();